import { ColumnProps, GridView, SimpleView, Table, Widget, Button, Form, Row, FormInput, Col, FormResetButton, FilterWidget, FormSelect, FormSubmitButton, MasterDetailForm, FormDatePicker, FormRangePicker } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, Tooltip } from 'antd';
import {
    exportarUsuarioUltimaAcessoFiltro,
    getAllUsuarioUltimaAcessoFiltro,
    UsuarioUltimaAcesso,
    UsuarioUltimaAcessoFiltro
} from '@app/api/usuario';
import { compareText } from '@app/helpers/comparators';
import ModalHistoricoAcessoUsuario from './ModalHistoricoAcessoUsuario';
const { Panel } = Collapse;

const UsuarioUltimoAcesso = () => {

    const [result, setResult] = useState([] as UsuarioUltimaAcesso[]);
    const [filtro, setFiltro] = useState<UsuarioUltimaAcessoFiltro>({} as UsuarioUltimaAcessoFiltro);


    useEffect(() => {
        GetAll();
    }, []);


    const GetAll = () => {
        getAllUsuarioUltimaAcessoFiltro(filtro).then((data) => {
            if (data)
                setResult(data);
        });
    }

    const colunas = useMemo(() => {
        let colluns: ColumnProps<UsuarioUltimaAcesso>[] = new Array();
        colluns.push(
            {
                title: 'N',
                dataIndex: 'numeroLinha',
                align: 'center',
            },
            {
                title: 'Nome',
                dataIndex: 'nome',
                sorter: (a, b) => compareText(a.nome, b.nome),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="nome"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.nome !== undefined &&
                    record.nome
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },
            {
                title: 'User Name',
                dataIndex: 'userName',
                sorter: (a, b) => compareText(a.userName, b.userName),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="userName"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.userName !== undefined &&
                    record.userName
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },
            {
                title: 'E-Mail',
                dataIndex: 'email',
                sorter: (a, b) => compareText(a.email, b.email),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="email"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.email !== undefined &&
                    record.email
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },
            {
                title: 'Status',
                dataIndex: 'statusUsuario',
                align: 'center',
                sorter: (a, b) => compareText(a.statusUsuario, b.statusUsuario),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="statusUsuario"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.statusUsuario !== undefined &&
                    record.statusUsuario
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },
            {
                title: 'Data do Último Acesso',
                dataIndex: 'ultimoAcesso',
                align: 'center',
                sorter: (a, b) => compareText(a.ultimoAcesso, b.ultimoAcesso),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="ultimoAcesso"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.ultimoAcesso !== undefined &&
                    record.ultimoAcesso
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },
            {
                title: 'Total de Dias Sem Acesso',
                dataIndex: 'quantidadeDiasSeAcessoAoSistema',
                align: 'center',
                sorter: (a, b) => compareText(a.quantidadeDiasSeAcessoAoSistema, b.quantidadeDiasSeAcessoAoSistema),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="quantidadeDiasSeAcessoAoSistema"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.quantidadeDiasSeAcessoAoSistema !== undefined &&
                    record.quantidadeDiasSeAcessoAoSistema
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },
            {
                title: 'Histórico de Acesso',
                align: 'center',
                render: (text, record) => {
                    return <ModalHistoricoAcessoUsuario usuarioId={record.usuarioId} />
                }
            }
        );
        return colluns;
    }, []);

    const onSearch = (values: UsuarioUltimaAcessoFiltro) => {
        setFiltro(values);
        getAllUsuarioUltimaAcessoFiltro(values).then((data) => {
            if (data)
                setResult(data);
        });
    }

    return (
        <>
            <SimpleView >
                <GridView noform>
                    <MasterDetailForm
                        key="filtroPesquisa"
                        initialValues={filtro}
                        onSubmit={onSearch}>
                        <FilterWidget
                            title="FILTROS DE PESQUISA"
                            actions={[                               
                                <FormSubmitButton icon={'commons-search'}>
                                    Pesquisar
                                </FormSubmitButton>
                            ]}>

                            <FormRangePicker
                                startName="dataInicio"
                                endName="dataFinal"
                                format="DD/MM/YYYY"
                                span={3}
                            />,


                        </FilterWidget>
                    </MasterDetailForm >

                    <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                        <Panel key="1" header="Relatório de Usuários por Data de Login" style={{ border: 0 }}>
                            <Widget actions={[
                                <Button
                                    type="primary"
                                    size={'small'}
                                    icon="files-ms_excel"
                                    onClick={() => {
                                        exportarUsuarioUltimaAcessoFiltro(filtro);
                                    }}
                                >
                                    Exporta para Excel
                                </Button>
                            ]}>
                                <Table
                                    rowKey="id"
                                    columns={colunas}
                                    dataSource={result}
                                />
                            </Widget>
                        </Panel>
                    </Collapse>
                </GridView>
            </SimpleView>
        </>);
}


export default UsuarioUltimoAcesso;

